export enum DatalabPostMessageType {
  // Datalab 通知承接页面
  ComponentMounted = 'componentMounted', // 通知承接页面 Iframe页面已渲染完成
  ClickExplore = 'clickExplore', // 通知承接页面, 用户点击了探索按钮
  RefreshToken = 'refreshToken', // token过期后重新请求的token
  GoBackReport = 'goBackReport', // 从探索图表页面返回报表承接页面
  ClickFullscreen = 'clickFullscreen', // 点击表格放大
  
  // 承接页面发送过来的消息类型
  InitData = 'initData', // 页面加载完成后 首次获取token, dashboardId, 等数据
  UpdateToken = 'updateToken', // token过期后重新请求的token
  ChangeLanguage = 'changeLanguage', // 转换中英文
  ChangeTheme = 'changeTheme', // 转换主题颜色
}

export type TDatalabCommunicatorData = {
  token: string;
  dashboardId: string;
  origin?: string;
  dashboardName?: string;
  gameCode?: string;
  theme?: TThemeInfo;
  [key: string]: any; // 允许其他可能的字段
}

// 主题名称
export const DATALAB_IFRAME_THEME_LIGHT = 'Light';
export const DATALAB_IFRAME_THEME_DARK = 'Dark';

export type TThemeInfo = {
  name: 'Dark' | 'Light' | undefined; // 主题名称
  invert?: string;  // css filter: invert(数值), 默认100%
}


